import { CollectedOrderState } from 'b2b-apps/shop/collectedOrder/redux/types';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import {
  CollectedOrderDataType,
  PlaceCollectedOrderDataType,
} from 'b2b-common/core/collectedOrder/CollectedOrder.types';

const getState = (state: State): CollectedOrderState => state.collectedOrder;

const getCollectedOrderIsEnabled = (state: State): boolean | null => getState(state).isEnabled;

const getCollectedOrderData = (state: State): CollectedOrderDataType => getState(state).data;

const getPlaceCollectedOrder = (
  state: State,
): RemoteRecord<PlaceCollectedOrderDataType> => new RemoteRecord(getState(state).place);

export {
  getCollectedOrderData,
  getCollectedOrderIsEnabled,
  getPlaceCollectedOrder,
  getState,
};
